
import { UIComponent } from "../../../dom-ui/components/UIComponent";
import { SplitView } from "../../../dom-ui/components/SplitView";
import { LinkedGraphicalElement } from "../../../dom-ui/graphical/LinkedGraphicalElement";
import { ToolBar } from "./ToolBar";
import { ElementType } from "../../../dom-tools/ElementType";
import { LinkedGraphicalElementList } from "../../../dom-ui/graphical/LinkedGraphicalElementList";
import { NotesEditor } from "./NotesEditor";
import { Arranger } from "./Arranger";
import { UIProperty } from "../../../dom-ui/basics/UIProperty";

export class MainView extends UIComponent
{
  static readonly elementType = new ElementType( "composer-main-view" );

  readonly toolBar = new LinkedGraphicalElement<ToolBar>( this ); 
  readonly toolBarHeight = new UIProperty( this, 25 );

  readonly split = new LinkedGraphicalElement<SplitView>( this );


  readonly arranger = new Arranger();
  readonly notesEditor = new NotesEditor();

  constructor()
  {
    super();

    this._setElement( MainView.elementType.create() );

    this.toolBar.value = new ToolBar();
    this.split.value = new SplitView();

    this.split.value.views.add( this.arranger );
    this.split.value.views.add( this.notesEditor );
  }

  _update()
  {
    super._update();

    if ( this.toolBar.value )
    {
      this.toolBar.value.dimensions.set( 
        0, 0, 
        this.width, this.toolBarHeight.value 
      );
    }

    if ( this.split.value )
    {
      this.split.value.dimensions.set( 
        0, this.toolBarHeight.value, 
        this.width, this.height - this.toolBarHeight.value 
      );
    }
    
   
  }

}